import React, { FunctionComponent } from "react"

import { Layout, SectionFull, Container, SEO } from "components"

import ContactForm from "views/contact/ContactForm"
import useTranslate from "logic/hooks/use-translate"
import styled from "styled-components"
import tw from "twin.macro"
import { graphql } from "gatsby"
import { ContactType } from "model/content"
import ContactInfo from "views/contact/ContactInfo"

interface ContactPageProps {
  data: {
    contentfulContactSingle: ContactType
  }
}

export const ContactSection = styled(SectionFull)`
  ${tw`pb-16 lg:pb-24 lg:-mt-16`};

  &:after {
    ${tw`absolute inset-0 w-full h-full bg-gray-100`}
    content: "";
    z-index: -1;
  }
`

export const ContactContainer = styled(Container)`
  ${tw`flex flex-col lg:flex-row px-4 md:px-12`}
`

const ContactPage: FunctionComponent<ContactPageProps> = ({
  data: { contentfulContactSingle },
}) => {
  const { CONTACT } = useTranslate(["CONTACT"])

  return (
    <Layout pageTheme="light">
      <SEO title={CONTACT} />
      <ContactSection>
        <ContactContainer>
          <ContactInfo {...contentfulContactSingle} />
          <ContactForm />
        </ContactContainer>
      </ContactSection>
    </Layout>
  )
}

export default ContactPage

export const query = graphql`
  query ContactPage($language: String) {
    contentfulContactSingle(node_locale: { eq: $language }) {
      heading
      writeHeading
      writeParagraph
      locationHeading
      locationParagraph
      phoneHeading
      phone
      email
    }
  }
`
